import { T } from "@tldraw/validate";
import { createShapePropsMigrationSequence } from "../records/TLShape.mjs";
const frameShapeProps = {
  w: T.nonZeroNumber,
  h: T.nonZeroNumber,
  name: T.string
};
const frameShapeMigrations = createShapePropsMigrationSequence({
  sequence: []
});
export {
  frameShapeMigrations,
  frameShapeProps
};
//# sourceMappingURL=TLFrameShape.mjs.map
